import { render, staticRenderFns } from "./DiSrc.vue?vue&type=template&id=82ec5daa&scoped=true&"
import script from "./DiSrc.vue?vue&type=script&lang=js&"
export * from "./DiSrc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ec5daa",
  null
  
)

export default component.exports